module.exports = __webpack_public_path__ + "img/lukoil-logo-en.67697b35.png";